exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-wrapper-file[data-v-57a641d7]{--tw-bg-opacity:1;background-color:rgba(244,244,244,var(--tw-bg-opacity));--tw-border-opacity:1;border-color:rgba(209,213,219,var(--tw-border-opacity));border-radius:.25rem;border-width:1px;height:6rem;margin-bottom:.25rem}", ""]);

// exports
